function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * 弧形
 */
export var ArcCurve = /*#__PURE__*/function () {
  function ArcCurve() {
    var rx = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
    var ry = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
    var axisRotation = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
    var
    //large arc 允许选择一个大弧线（1）或一个小弧线（0），
    lrc = arguments.length > 3 ? arguments[3] : undefined;
    var
    //sweep-flag 允许选择一条顺时针旋转的弧线（1）或一条逆时针旋转的弧线（0）
    sweep = arguments.length > 4 ? arguments[4] : undefined;
    var to = arguments.length > 5 ? arguments[5] : undefined;
    _classCallCheck(this, ArcCurve);
    _defineProperty(this, "type", 'ArcCurve');
    this.rx = rx;
    this.ry = ry;
    this.axisRotation = axisRotation;
    this.lrc = lrc;
    this.sweep = sweep;
    this.to = to;
  } // super("ArcCurve")

  // parseArc2(start: IVector2d) {
  //     let rx = this.rx;
  //     let ry = this.ry;
  //     let x_axis_rotation = this.axisRotation;
  //     let large_arc_flag = this.lrc ? 1 : 0;
  //     let sweep_flag = this.sweep ? 1 : 0;
  //     let end: IVector2d = this.to;
  //
  //     x_axis_rotation = x_axis_rotation * Math.PI / 180;
  //
  //     // Ensure radii are positive
  //     rx = Math.abs( rx );
  //     ry = Math.abs( ry );
  //
  //     // Compute (x1', y1')
  //     const dx2 = ( start.x - end.x ) / 2.0;
  //     const dy2 = ( start.y - end.y ) / 2.0;
  //     const x1p = Math.cos( x_axis_rotation ) * dx2 + Math.sin( x_axis_rotation ) * dy2;
  //     const y1p = - Math.sin( x_axis_rotation ) * dx2 + Math.cos( x_axis_rotation ) * dy2;
  //
  //     // Compute (cx', cy')
  //     let rxs = rx * rx;
  //     let rys = ry * ry;
  //     const x1ps = x1p * x1p;
  //     const y1ps = y1p * y1p;
  //
  //     // Ensure radii are large enough
  //     const cr = x1ps / rxs + y1ps / rys;
  //
  //     if ( cr > 1 ) {
  //
  //         // scale up rx,ry equally so cr == 1
  //         const s = Math.sqrt( cr );
  //         rx = s * rx;
  //         ry = s * ry;
  //         rxs = rx * rx;
  //         rys = ry * ry;
  //
  //     }
  //
  //     const dq = ( rxs * y1ps + rys * x1ps );
  //     const pq = ( rxs * rys - dq ) / dq;
  //     let q = Math.sqrt( Math.max( 0, pq ) );
  //     if ( large_arc_flag === sweep_flag ) q = - q;
  //     const cxp = q * rx * y1p / ry;
  //     const cyp = - q * ry * x1p / rx;
  //
  //     // Step 3: Compute (cx, cy) from (cx', cy')
  //     const cx = Math.cos( x_axis_rotation ) * cxp - Math.sin( x_axis_rotation ) * cyp + ( start.x + end.x ) / 2;
  //     const cy = Math.sin( x_axis_rotation ) * cxp + Math.cos( x_axis_rotation ) * cyp + ( start.y + end.y ) / 2;
  //
  // }
  /**
   * https://www.w3.org/TR/SVG/implnote.html#ArcImplementationNotes
   * https://mortoray.com/2017/02/16/rendering-an-svg-elliptical-arc-as-bezier-curves/ Appendix: Endpoint to center arc conversion
   * From
   * rx ry x-axis-rotation large-arc-flag sweep-flag x y
   * To
   * aX, aY, xRadius, yRadius, aStartAngle, aEndAngle, aRotation, sweep
   */
  _createClass(ArcCurve, [{
    key: "parseArc",
    value: function parseArc(begin) {
      var rx = this.rx,
        ry = this.ry,
        axisRotation = this.axisRotation,
        sweepFlag = this.sweep,
        end = this.to;
      var lrc = this.lrc;
      var rotation = axisRotation * Math.PI / 180;
      // Ensure radii are positive
      rx = Math.abs(rx);
      ry = Math.abs(ry);

      // Compute (x1', y1')
      var dx2 = (begin.x - end.x) / 2.0;
      var dy2 = (begin.y - end.y) / 2.0;
      var x1p = Math.cos(rotation) * dx2 + Math.sin(rotation) * dy2;
      var y1p = -Math.sin(rotation) * dx2 + Math.cos(rotation) * dy2;

      // Compute (cx', cy')
      var rxs = rx * rx;
      var rys = ry * ry;
      var x1ps = x1p * x1p;
      var y1ps = y1p * y1p;

      // Ensure radii are large enough
      var cr = x1ps / rxs + y1ps / rys;
      if (cr > 1) {
        // scale up rx,ry equally so cr == 1
        var s = Math.sqrt(cr);
        rx = s * rx;
        ry = s * ry;
        rxs = rx * rx;
        rys = ry * ry;
      }
      var dq = rxs * y1ps + rys * x1ps;
      var pq = (rxs * rys - dq) / dq;
      var q = Math.sqrt(Math.max(0, pq));
      if (lrc === sweepFlag) q = -q;
      var cxp = q * rx * y1p / ry;
      var cyp = -q * ry * x1p / rx;

      // Step 3: Compute (cx, cy) from (cx', cy')
      var cx = Math.cos(rotation) * cxp - Math.sin(rotation) * cyp + (begin.x + end.x) / 2;
      var cy = Math.sin(rotation) * cxp + Math.cos(rotation) * cyp + (begin.y + end.y) / 2;
      // console.log({
      //     cx, cy
      // })
      // Step 4: Compute θ1 and Δθ
      var theta = svgAngle(1, 0, (x1p - cxp) / rx, (y1p - cyp) / ry);
      var delta = svgAngle((x1p - cxp) / rx, (y1p - cyp) / ry, (-x1p - cxp) / rx, (-y1p - cyp) / ry) % (Math.PI * 2);
      return [cx, cy, rx, ry, theta, theta + delta, axisRotation, sweepFlag];
    }
  }]);
  return ArcCurve;
}();
function svgAngle(ux, uy, vx, vy) {
  var dot = ux * vx + uy * vy;
  var len = Math.sqrt(ux * ux + uy * uy) * Math.sqrt(vx * vx + vy * vy);
  var ang = Math.acos(Math.max(-1, Math.min(1, dot / len))); // floating point precision, slightly over values appear
  if (ux * vy - uy * vx < 0) ang = -ang;
  return ang;
}